import { IdleInterruptSourceDocument } from './interrupt-source-document';
import { IdleInterruptSourceEventTargetOptions } from './interrupt-source-event-target';
import { IdleInterruptSourceStorage } from './interrupt-source-storage';
import { IdleInterruptSourceWindow } from './interrupt-source-window';

export function createDefaultInterruptSources(options?: IdleInterruptSourceEventTargetOptions) {
    return [
        new IdleInterruptSourceDocument('mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll', options),
        new IdleInterruptSourceStorage(options),
        new IdleInterruptSourceWindow('focus blur', options)
    ];
}

export const DEFAULT_INTERRUPT_SOURCES = createDefaultInterruptSources();
